<template>
  <div class="mb15 mt20 payment-cash-on-delivery-info-container">
    <h4 class="mt0">
      Informace o platbě
    </h4>
    <div class="bg-cl-secondary px20 py20">
      <p>
        Tuto položku zaplatíte při převzetí
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentCashOnDelivery',
  data () {
    return {}
  }
}
</script>
